/* DSL Klaviyo newsletter handler */
(function(){
  var COMPANY_ID = (window.DSL_CONFIG && window.DSL_CONFIG.klaviyoCompanyId) || "";
  if (!COMPANY_ID) return;
  // Load Klaviyo Onsite SDK
  var s = document.createElement("script");
  s.async = true;
  s.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=" + encodeURIComponent(COMPANY_ID);
  document.head.appendChild(s);
  // Honeypot-aware form submit
  document.addEventListener("submit", function(e){
    var f = e.target;
    if (!f.classList || !f.classList.contains("klaviyo-form")) return;
    e.preventDefault();
    var hp = f.querySelector("[name=newsletter_dsl_hp]");
    var msg = f.querySelector(".dsl-newsletter__msg");
    if (hp && hp.value) { msg.textContent = ""; return; } // bot
    var email = f.querySelector("[name=email]").value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = "Vul een geldig e-mailadres in."; return; }
    var listId = f.dataset.listId;
    var endpoint = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
    var fd = new FormData();
    fd.append("g", listId);
    fd.append("email", email);
    fd.append("$fields", "$source");
    fd.append("$source", location.pathname);
    fetch(endpoint, {method:"POST", body: fd, mode:"no-cors"}).then(function(){
      msg.textContent = "Welkom! Check je inbox voor de bevestigingsmail.";
      f.querySelector("[name=email]").value = "";
      if (window.DSL_AB) window.DSL_AB.track("newsletter_signup", {list: listId, source: location.pathname});
    }).catch(function(){ msg.textContent = "Er ging iets mis. Probeer het zo nogmaals."; });
  }, true);
})();